import { AnalyticsEventName } from './constants';
import { trackEvent } from './utils';

export const trackPageExceptionEvent = () => {
  trackEvent({
    eventName: AnalyticsEventName.Exception,
    parameters: {}
  });
};
